export const TOGGLE_LOADING = 'dict/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'dict/TOGGLE_SUCCESS'
export const SET_DICT_VERSION = 'dict/SET_DICT_VERSION'
